import { Alert, Button } from 'antd';
import { Profile } from 'oidc-client';
import React, { useRef, useState } from 'react';
import { isUserAdmin } from '../../helpers/CheckPermissionHelper';
import { apiErrorText } from '../../helpers/NotificationHelper';
import { UsersClient, UserVm } from '../../utils/api';

interface Props {
    user?: UserVm;
    userProfile?: Profile;
}

export default function ResendConfirmation({ user, userProfile }: Props): React.ReactElement | null {
    const pending = useRef(false);
    const [sending, setSending] = useState(false);
    const [sent, setSent] = useState(false);
    const [error, setError] = useState<string>();
    if (!user?.id || user.emailConfirmed !== false || !userProfile || !isUserAdmin(userProfile)) return null;

    const resend = async (): Promise<void> => {
        if (pending.current) return;
        pending.current = true;
        setSending(true);
        setSent(false);
        setError(undefined);
        try {
            await new UsersClient().resendConfirmation(user.id);
            setSent(true);
        } catch (failure) {
            setError(apiErrorText(failure));
        } finally {
            pending.current = false;
            setSending(false);
        }
    };

    return (
        <div style={{ marginBottom: 16 }}>
            <Button loading={sending} disabled={sending} onClick={(): void => { void resend(); }}>
                Resend confirmation
            </Button>
            {sent && <Alert type="success" showIcon message="Confirmation email sent." />}
            {error && <Alert type="error" showIcon message={error} />}
        </div>
    );
}
